(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-request-form"] && !Shopify.designMode) return;
  try {
    const readSelectedOptions = (sectionId) => {
    const section = document.getElementById(`shopify-section-${sectionId}`)
    const picker = section?.querySelector('variant-picker')
    if (!picker) return []

    const options = []

    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const checked = fieldset.querySelector('input[type="radio"]:checked')
      if (!checked) continue

      const label = fieldset.querySelector('.form__label')
      const name = label ? label.textContent.split(':')[0].trim() : ''
      const normalized = name.toLowerCase()
      const isColor = Boolean(fieldset.querySelector('.color-swatch')) || normalized.includes('kleur') || normalized.includes('color') || normalized.includes('colour')
      options.push({ name, value: checked.value, isColor })
    }

    return options
  }

  const prefillRequest = (root) => {
    const length = root.querySelector('[data-request-length]')
    const width = root.querySelector('[data-request-width]')
    const color = root.querySelector('[data-request-color]')
    const colorField = color?.closest('.field')
    const options = readSelectedOptions(root.dataset.sectionId)
    let colorValue = ''

    for (const option of options) {
      const name = option.name.toLowerCase()
      const digits = option.value.replace(/[^\d]/g, '')

      if (digits) {
        if (length && !length.dataset.touched && name.includes('lengte')) length.value = digits
        if (width && !width.dataset.touched && name.includes('breed')) width.value = digits
      }

      if (option.isColor) colorValue = option.value
    }

    if (color) color.value = colorValue
    if (colorField) colorField.hidden = colorValue === ''
  }

  const writeRequestSummary = (root) => {
    const summary = root.querySelector('[data-request-summary]')
    if (!summary) return

    const options = readSelectedOptions(root.dataset.sectionId)
    const lines = []

    if (root.dataset.productTitle) lines.push(root.dataset.productTitle)

    for (const option of options) {
      lines.push(`${option.name}: ${option.value}`)
    }

    if (root.dataset.productUrl) lines.push(root.dataset.productUrl)
    summary.value = lines.join('\n')
  }

  document.addEventListener('drawer:afterShow', (event) => {
    const root = event.target.querySelector('[data-product-request]')
    if (!root) return
    prefillRequest(root)
  })

  document.addEventListener('input', (event) => {
    const field = event.target
    if (!(field instanceof HTMLInputElement)) return
    if (!field.matches('[data-request-length], [data-request-width]')) return
    field.dataset.touched = 'true'
  })

  document.addEventListener('submit', (event) => {
    const form = event.target
    if (!(form instanceof HTMLFormElement)) return

    const root = form.closest('[data-product-request]')
    if (!root) return
    writeRequestSummary(root)
  })

  const prefillInlineRequests = () => {
    for (const root of document.querySelectorAll('[data-product-request][data-presentation="inline"]')) {
      prefillRequest(root)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillInlineRequests)
  } else {
    prefillInlineRequests()
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["selling-plan-picker"] && !Shopify.designMode) return;
  try {
    const initDt69StoqBypass = () => {
    if (window.__dt69StoqBypass?.initialized) {
      return;
    }

    const bypass = {
      initialized: true,
      buttonObserver: null,

      isThemeControlledForm(form) {
        return Boolean(form?.querySelector('selling-plan-picker:not([hidden]) input[name="selling_plan_option"]'));
      },

      hasThemePickerOnPage() {
        return Boolean(document.querySelector('.selling-plan:not([hidden]) input[name="selling_plan_option"]'));
      },

      stripStoqSubmitButtons(root = document) {
        if (!this.hasThemePickerOnPage()) {
          return;
        }

        for (const button of root.querySelectorAll('form[is="product-form"] [type="submit"]')) {
          button.classList.remove('restock-rocket-preorder-button');
        }
      },

      bind() {
        this.buttonObserver = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.attributeName !== 'class') {
              continue;
            }

            const button = mutation.target;
            if (!(button instanceof HTMLButtonElement) || button.type !== 'submit') {
              continue;
            }

            const form = button.closest('form[is="product-form"]');
            if (!this.isThemeControlledForm(form)) {
              continue;
            }

            if (button.classList.contains('restock-rocket-preorder-button')) {
              button.classList.remove('restock-rocket-preorder-button');
            }
          }
        });

        const observeSubmitButtons = () => {
          for (const button of document.querySelectorAll('form[is="product-form"] [type="submit"]')) {
            this.buttonObserver.observe(button, { attributes: true, attributeFilter: ['class'] });
          }
        };

        observeSubmitButtons();
        window.addEventListener('stoq:loaded', observeSubmitButtons);
        document.addEventListener('shopify:section:load', observeSubmitButtons);
      }
    };

    bypass.bind();
    window.__dt69StoqBypass = bypass;
  };

  initDt69StoqBypass();

  const removeStoqPaymentWidgets = (container) => {
    if (!container) return;

    container.querySelectorAll('.restock-rocket-payment-widget').forEach((widget) => {
      widget.remove();
    });
  };

  if (!customElements.get('selling-plan-picker')) {
    class SellingPlanPicker extends HTMLElement {
      #observer;
      #recheckTimeouts = [];

      connectedCallback() {
        this.addEventListener('change', this.#onChange);
        this.addEventListener('selling-plan:updated', this.#onSellingPlanUpdated);
        this.#observeButtons();
        this.#syncStoqState();
        this.#scheduleRechecks();
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#clearRechecks();
      }

      #onChange = (event) => {
        const option = event.target;

        if (!(option instanceof HTMLInputElement)) return;
        if (option.name !== 'selling_plan_option') return;

        const planInput = this.querySelector('input[name="selling_plan"]');
        if (!planInput) return;

        planInput.value = option.value;
      };

      #onSellingPlanUpdated = () => {
        this.#syncStoqState();
        this.#scheduleRechecks();
      };

      #observeButtons() {
        const buttons = this.closest('.product-form__buttons');
        if (!buttons) return;

        this.#observer = new MutationObserver(() => {
          this.#syncStoqState();
        });
        this.#observer.observe(buttons, { childList: true, subtree: true });
      }

      #clearRechecks() {
        for (const timeoutId of this.#recheckTimeouts) {
          clearTimeout(timeoutId);
        }
        this.#recheckTimeouts = [];
      }

      #scheduleRechecks() {
        this.#clearRechecks();

        for (const delay of [150, 400, 900]) {
          this.#recheckTimeouts.push(window.setTimeout(() => {
            this.#syncStoqState();
          }, delay));
        }
      }

      #syncStoqState = () => {
        const buttons = this.closest('.product-form__buttons');
        removeStoqPaymentWidgets(buttons);

        for (const button of buttons?.querySelectorAll('[type="submit"]') || []) {
          button.classList.remove('restock-rocket-preorder-button');
        }

        if (!this.querySelector('[name="selling_plan_option"]')) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
      };
    }

    customElements.define('selling-plan-picker', SellingPlanPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
